import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ExploreSearch from "./SearchPage/ExploreSearch";
import { useNavigate } from "react-router-dom";
import { useGetProfileInformationQuery } from "../../../Redux/apis/ApiSlice";
import { notification } from "antd";
import { clearEditTicket } from "../../../Redux/Slices/editTicketSlice";
import { clearEditEventInfo } from "../../../Redux/Slices/editEventInfoSlice";
import { clearTicketPayload } from "../../../Redux/Slices/ticketPayloadSlice";
import { useDispatch } from "react-redux";
export default function ExploreEventsPage() {
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [filters, setFilters] = useState({
    eventName: "",
    location: "",
    dateRange: [],
  });
  const [onBoarding, setOnboarding] = React.useState();
  const navigate = useNavigate();
  useEffect(() => {
    // Extract query parameters
    const eventName = queryParams.get("eventName") || "";
    const startDate = queryParams.get("startDate")
      ? new Date(queryParams.get("startDate"))
      : null;
    const endDate = queryParams.get("endDate")
      ? new Date(queryParams.get("endDate"))
      : null;

    // Determine dateRange based on presence of dates
    const dateRange = startDate && endDate ? [startDate, endDate] : [];

    setFilters({
      eventName,
      location: "", // If location needs to be set, extract it from queryParams as well
      dateRange,
    });
  }, [location.search]);
  const { data: profileData, refetch: fetchProfileData } =
    useGetProfileInformationQuery();

  useEffect(() => {
    fetchProfileData(); // Force a refetch mount
  }, []);

  useEffect(() => {
    if (profileData) {
      setOnboarding(profileData.user.onBoarding);
    }
  }, [profileData]);

  const handleEventClick = () => {
    if (onBoarding === false) {
      notification.error({
        
        message:
          "Complete onboarding in Settings before adding events!",
      });
      navigate("/settings", { state: { from: "login" } });
      return;
    }
    dispatch(clearEditTicket());
    dispatch(clearEditEventInfo());
    dispatch(clearTicketPayload());
    // navigate("/add-event");
  };
  // Function to update filters
  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };
  // Inline styles for the floating button
  const floatingButtonStyle = {
    position: "absolute",
    bottom: "20px", // Adjust spacing from the bottom
    right: "20px", // Adjust spacing from the right
    backgroundColor: "#061F44", // Brand color
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "10px 20px",
    fontSize: "16px",
    fontWeight: "600",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", // Optional: Add shadow for aesthetics
    cursor: "pointer",
    zIndex: 1000, // Ensure it stays on top
    transition: "transform 0.2s ease, background-color 0.3s ease",
  };
  return (
    <div style={{ height: "100vh" }}>
      <ExploreSearch filters={filters} onFilterChange={handleFilterChange} />
    </div>
  );
}
